import { Component, Output, EventEmitter, Input } from '@angular/core';
import { Paciente } from 'app/core/interfaces/pacient-info.interface';

@Component({
  selector: 'app-item-paciente-secretaria',
  templateUrl: './item-paciente-secretaria.component.html',
  styleUrls: ['./item-paciente-secretaria.component.scss']
})
export class ItemPacienteSecretariaComponent {

  @Output() ver = new EventEmitter();
  @Output() editar = new EventEmitter();
  @Input() paciente: Paciente;
  @Input() numero_paciente: number;

  @Input() ativado: boolean = false;
  @Input() encerrado: boolean = false;

  constructor () {}

  getCartaoStatus(ativado = false, encerrado = false) {
    if (encerrado) {
      return 'Encerrado';
    }
    if (!ativado) {
      return 'Desativado';
    }

    return 'Ativo';
  }

}
